// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Overlay from './Overlay';
import type { MapViewer } from '../../../../types/VisioglobeType';
import type { BranchLevelGemini, ShoppingCenterGemini, VisioglobeUnitsMap } from '../../../../types/geminiType';
import geminiApi from '../../../../network/api/geminiApi';
import { getCurrentPcId } from '../../../../utils/urlUtils';
import { AVG_TYPE, SUM_TYPE } from './geminiConst';
import EllipsisLoader from '../../../../components/EllipsisLoader';
import { notifyApolloError } from '../../../../network/notification';

type Props = {
  dispatch: Dispatch,
  mapviewer: MapViewer,
  scrollableElement?: ?HTMLDivElement,
  changeMappingMode: () => void,
  isMappingUser: boolean,
  isGeminiAdmin: boolean,
  isPulseAuthorized: boolean,
}

type State = {
  shoppingCenterData: ?ShoppingCenterGemini,
  branchKpiSum: BranchLevelGemini[],
  branchKpiAvg: BranchLevelGemini[],
  visioglobeUnitsMap: ?VisioglobeUnitsMap,
}

class GeminiOverlay extends React.Component<Props, State> {
  static defaultProps = {
    scrollableElement: null,
  };

  state = {
    shoppingCenterData: null,
    branchKpiSum: [],
    branchKpiAvg: [],
    visioglobeUnitsMap: null,
  };

  updateVisioglobeUnits = (year?: string) => {
    const pcId = getCurrentPcId();
    this.fetchShoppingCenter(pcId, year);
    this.fetchBranchLevels(pcId, year);
    this.fetchVisioglobeUnits(pcId, year);
  }

  fetchShoppingCenter = (pcId: string, year?: string) => {
    this.setState({ shoppingCenterData: null }, () => {
      geminiApi.fetchShoppingCenter(pcId, year)
        .then(res => res.json())
        .then((shoppingCenterData: ShoppingCenterGemini) => {
          this.setState({ shoppingCenterData });
        })
        .catch(e => this.props.dispatch(notifyApolloError(e)));
    });
  }

  fetchBranchLevels = (pcId: string, year?: string) => {
    this.setState({ branchKpiSum: [], branchKpiAvg: [] }, () => {
      geminiApi.fetchBranchLevels(pcId, year, SUM_TYPE)
        .then(res => res.json())
        .then((branchKpiSum: BranchLevelGemini[]) =>
          this.setState({ branchKpiSum }))
        .catch(e => this.props.dispatch(notifyApolloError(e)));
      geminiApi.fetchBranchLevels(pcId, year, AVG_TYPE)
        .then(res => res.json())
        .then((branchKpiAvg: BranchLevelGemini[]) =>
          this.setState({ branchKpiAvg }))
        .catch(e => this.props.dispatch(notifyApolloError(e)));
    });
  }

  fetchVisioglobeUnits = (pcId: string, year?: string) => {
    this.setState({ visioglobeUnitsMap: null }, () => {
      geminiApi.fetchVisioglobeUnits(pcId, year)
        .then(res => res.json())
        .then((visioglobeUnitsMap: VisioglobeUnitsMap) => {
          this.setState({ visioglobeUnitsMap });
        })
        .catch(e => this.props.dispatch(notifyApolloError(e)));
    });
  }

  componentDidMount() {
    this.updateVisioglobeUnits();
  }

  render() {
    if (!this.state.shoppingCenterData || !this.state.visioglobeUnitsMap) {
      return (
        <div className="loader-screen">
          <EllipsisLoader />
        </div>
      );
    }
    return (
      <Overlay
        updateVisioglobeUnits={this.updateVisioglobeUnits}
        scrollableElement={this.props.scrollableElement}
        branchKpi={this.state.branchKpiSum}
        branchKpiAvg={this.state.branchKpiAvg}
        visioglobeUnitsMap={this.state.visioglobeUnitsMap}
        shoppingCenterData={this.state.shoppingCenterData}
        mapviewer={this.props.mapviewer}
        changeMappingMode={this.props.changeMappingMode}
        isMappingUser={this.props.isMappingUser}
        isGeminiAdmin={this.props.isGeminiAdmin}
        isPulseAuthorized={this.props.isPulseAuthorized}
      />
    );
  }
}

export default connect()(GeminiOverlay);
